export default __webpack_public_path__ + "static/media/infinite.918d807f.svg";